import React from 'react';
import Wishlist from '../components/Wishlist/Wishlist';

const WishlistPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Wishlist />
    </div>
  );
};

export default WishlistPage;